(function (window) {
  'use strict';

  function handleToggle(e) {
    const item = e.target.closest('.js-shopping-cart-item-gift-bag');
    toggleItem(item);
  }

  function handleGiftCardToggle(e) {
    const toggle = e.target;
    const container = toggle.parentNode.querySelector('.js-gift-card-apply-form');

    if (toggle.getAttribute('aria-expanded') === 'false') {
      updateVisibilityGiftCardFormElements(container, true);
      toggle.setAttribute('aria-expanded', true);
      container.setAttribute('aria-hidden', false);

      if ((window.innerWidth || screen.width) < 681) {
        const contentHeight = calculateElementContentHeight(container);
        container.style.height = contentHeight + 'px';
      }
    } else {
      updateVisibilityGiftCardFormElements(container, false);
      toggle.setAttribute('aria-expanded', false);
      container.setAttribute('aria-hidden', true);
      container.style.height = '';
    }
  }

  function updateVisibilityGiftCardFormElements(container, showFormElements) {
    const formInputElements = container.querySelectorAll('input, button')
    for (let i = 0; i < formInputElements.length; i++) {
      formInputElements[i].setAttribute('tabindex', (showFormElements ? '' : '-1'));
    }
  }

  function calculateHeight(container) {
    const contentHeight = Array.prototype.reduce.call(container.children, function (height, child) {
      const style = getComputedStyle(child);
      const total = height + child.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
      return total;
    }, 0);
    return contentHeight;
  }

  function handleRxToggle(e) {
    const toggle = e.target;
    const container = toggle.parentNode.querySelector('.js-shopping-cart-rx');
    if (toggle.getAttribute('aria-expanded') === 'false') {
      const contentHeight = calculateHeight(container);
      toggle.innerHTML = window.cart_i18n.hide_prescription_button_text;
      toggle.setAttribute('aria-expanded', true);
      container.setAttribute('aria-hidden', false);
      container.style.height = contentHeight + 'px';
    } else {
      toggle.innerHTML = window.cart_i18n.show_prescription_button_text;
      toggle.setAttribute('aria-expanded', false);
      container.setAttribute('aria-hidden', true);
      container.style.height = '';
    }
  }

  function toggleItem(item) {
    item.classList.toggle('js-shopping-cart-disable');
  }

  // To-do: consolidate this with the height calculation in
  // handleGiftCardToggle().
  function recalculateHeight() {
    const container = document.querySelector('.js-gift-card-apply-form');
    // If gift card form isn’t even on the page, exit.
    if (!container) return;

    if (container.getAttribute('aria-hidden') === 'false') {
      if ((window.innerWidth || screen.width) < 681) {
        const contentHeight = calculateElementContentHeight(container);
        container.style.height = contentHeight + 'px';
      }
    }
  }

  function handleShippingMethodChange(select) {
    const methodCell = findParent(select, 'js-shipping-method-cell');
    const toggle = methodCell.querySelector('.js-shipping-price-toggle');

    if (select.value) {
      toggle.setAttribute('aria-hidden', false);
    } else {
      toggle.setAttribute('aria-hidden', true);
    }
  }

  function handleShippingPriceToggle(event) {
    const toggles = document.querySelectorAll('.js-shipping-price-toggle');
    const placeholders = document.querySelectorAll('.js-shipping-price-placeholder');
    const values = document.querySelectorAll('.js-shipping-price-value');

    // Flip reveal data attribute.
    document.body.dataset.shippingPricesRevealed = document.body.dataset.shippingPricesRevealed !== "true";
    const reveal = document.body.dataset.shippingPricesRevealed === "true";

    Array.prototype.forEach.call(toggles, function (toggle) {
      // Update toggle text according to reveal status.
      toggle.innerText = reveal ? window.cart_i18n.hide_shipping_price_button_text : window.cart_i18n.show_shipping_price_button_text;
    });
    Array.prototype.forEach.call(placeholders, function (placeholder) {
      // Hide placeholder if `reveal` is true, otherwise, show it.
      placeholder.setAttribute('aria-hidden', reveal);
    });
    Array.prototype.forEach.call(values, function (value) {
      // Show value if `reveal` is true, otherwise, hide it.
      value.setAttribute('aria-hidden', !reveal);
    });
  }

  function init() {
    // Define cart_i18n object if it doesn’t already exist.
    window.cart_i18n = window.cart_i18n || {};
    if (!window.cart_i18n.hasOwnProperty('show_shipping_price_button_text') || window.cart_i18n.show_shipping_price_button_text === '') {
      window.cart_i18n.show_shipping_price_button_text = 'Show shipping price';
    }
    if (!window.cart_i18n.hasOwnProperty('hide_shipping_price_button_text') || window.cart_i18n.hide_shipping_price_button_text === '') {
      window.cart_i18n.hide_shipping_price_button_text = 'Hide shipping price';
    }
    if (!window.cart_i18n.hasOwnProperty('show_prescription_button_text') || window.cart_i18n.show_prescription_button_text === '') {
      window.cart_i18n.show_prescription_button_text = 'Show prescription details';
    }
    if (!window.cart_i18n.hasOwnProperty('hide_prescription_button_text') || window.cart_i18n.hide_prescription_button_text === '') {
      window.cart_i18n.hide_prescription_button_text = 'Hide prescription details';
    }

    // Instantiate gift bags.
    const giftBags = document.querySelectorAll('.js-shopping-cart-item-gift-bag');
    for (let i = 0; i < giftBags.length; i++) {
      if (!giftBags[i].classList.contains('js-component-init')) {
        const toggle = giftBags[i].querySelector('.checkbox');
        if (toggle) {
          toggle.addEventListener('click', handleToggle);
        }
        toggleItem(giftBags[i]);
        giftBags[i].classList.add('js-component-init');
      }
    }

    // Instantiate gift cards.
    const giftCards = document.querySelectorAll('.js-shopping-cart-item-gift-card');
    for (let i = 0; i < giftCards.length; i++) {
      if (!giftCards[i].classList.contains('js-component-init')) {
        giftCards[i].addEventListener('click', handleGiftCardToggle);
        giftCards[i].classList.add('js-component-init');
      }
    }

    // Instantiate rx toggles.
    const rxToggles = document.querySelectorAll('.js-shopping-cart-rx-toggle');
    for (let i = 0; i < rxToggles.length; i++) {
      if (!rxToggles[i].classList.contains('js-component-init')) {
        rxToggles[i].addEventListener('click', handleRxToggle);
        rxToggles[i].classList.add('js-component-init');
      }
    }

    // Instantiate shipping price toggles.
    const shippingPriceToggles = document.querySelectorAll('.js-shipping-price-toggle');
    for (let i = 0; i < shippingPriceToggles.length; i++) {
      if (!shippingPriceToggles[i].classList.contains('js-component-init')) {
        shippingPriceToggles[i].addEventListener('click', function (event) {
          if (event.target.classList.contains('js-shipping-price-toggle')) {
            handleShippingPriceToggle(event);
          }
        });
        shippingPriceToggles[i].classList.add('js-component-init');
      }
    }

    // Recalculate gift card form height in case it’s open on load.
    recalculateHeight();

    // Trigger a shipping-method-change event from shipping-dropdown component.
    componentEvents.emitEvent('shipping-method-update');
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
    componentEvents.on('shipping-method-changed', handleShippingMethodChange);
  }

  init();

})(this);
